import { getToken, axiosInstance } from "../../utils/Api";

export const createTvApk = async (data) => {

  try {

    const response = await axiosInstance.post(
      "/admin/tvapk/addTvApk",
      data,
      {
        headers: {
          Authorization: `Bearer ${ getToken() } `
        }
      }
    );

    return response.data;

  } catch (error) {

    throw error;

  }

};

export const updateTvApk = async (data) => {

  try {

    const response = await axiosInstance.put(
      "/admin/tvapk/updateTvApk",
      data,
      {
        headers: {
          Authorization: `Bearer ${ getToken() } `
        }
      }
    );

    return response.data;

  } catch (error) {

    throw error;

  }

};

export const getTvApkByID = async (tvApkId) => {

  try {

    const response = await axiosInstance.get(
      "/admin/tvapk/getTvApk",
      {
        params: {
          id: tvApkId
        },
        headers: {
          Authorization: `Bearer ${ getToken() } `
        }
      }
    );

    return response.data;

  } catch (error) {

    console.error("Error in getTvApkByID:", error);

    return false;

  }

};

export const deleteTvApkByID = async (tvApkId, active) => {

  try {

    const response = await axiosInstance.delete(
      "/admin/tvapk/deleteTvApk",
      {
        data: {
          tv_apk_id: tvApkId,
          active: active
        },
        headers: {
          Authorization: `Bearer ${ getToken() } `
        }
      }
    );

    return response.data;

  } catch (error) {

    console.error("Error in deleteTvApkByID:", error);

    return false;

  }

};

export const toggleTvApkActiveStatus = async (tvApkId, currentActive) => {

  try {

    const response = await axiosInstance.put(
      "/admin/tvapk/updateTvApk",
      {
        id: tvApkId,
        active: !currentActive
      },
      {
        headers: {
          Authorization: `Bearer ${ getToken() } `
        }
      }
    );

    return response.data;

  } catch (error) {

    console.error("Error in toggleTvApkActiveStatus:", error);

    return false;

  }

};

export const getTvApks = async () => {

  try {

    const response = await axiosInstance.get(
      "/admin/tvapk/getTvApkList",
      {
        headers: {
          Authorization: `Bearer ${ getToken() } `
        }
      }
    );

    return response.data;

  } catch (error) {

    throw error;

  }

};
export const createTvApkProject = async (data) => {

  try {

    const response = await axiosInstance.post(
      "/admin/tvapk/addTvApkProject",
      data,
      {
        headers: {
          Authorization: `Bearer ${ getToken() } `
        }
      }
    );

    return response.data;

  } catch (error) {

    throw error;

  }

};

export const updateTvApkProject = async (data) => {

  try {

    const response = await axiosInstance.put(
      "/admin/tvapk/updateTvApkProject",
      data,
      {
        headers: {
          Authorization: `Bearer ${ getToken() } `
        }
      }
    );

    return response.data;

  } catch (error) {

    throw error;

  }

};

export const getTvApkProjectByID = async (tvApkProjectId) => {

  try {

    const response = await axiosInstance.get(
      "/admin/tvapk/getTvApkProject",
      {
        params: {
          id: tvApkProjectId
        },
        headers: {
          Authorization: `Bearer ${ getToken() } `
        }
      }
    );

    return response.data;

  } catch (error) {

    console.error("Error in getTvApkProjectByID:", error);

    return false;

  }

};
export const getTvApkProjectAll = async (tvApkProjectId) => {

  try {

    const response = await axiosInstance.get(
      "/admin/tvapk/getAllTvApkProject",
      {
        headers: {
          Authorization: `Bearer ${ getToken() } `
        }
      }
    );

    return response.data;

  } catch (error) {

    console.error("Error in getTvApkProjectAll:", error);

    return false;

  }

};

export const deleteTvApkProjectByID = async (tvApkProjectId) => {

  try {

    const response = await axiosInstance.delete(
      "/admin/tvapk/deleteTvApkProject",
      {
        data: {
          tv_apk_project_id: tvApkProjectId
        },
        headers: {
          Authorization: `Bearer ${ getToken() } `
        }
      }
    );

    return response.data;

  } catch (error) {

    console.error("Error in deleteTvApkProjectByID:", error);

    return false;

  }

};
export const getTvApkProjects = async () => {

  try {

    const response = await axiosInstance.get(
      "/admin/tvapk/getTvApkProjectList",
      {
        headers: {
          Authorization: `Bearer ${ getToken() } `
        }
      }
    );

    return response.data;

  } catch (error) {

    throw error;

  }

};

// ======================================================
// TV APK SETTINGS
// ======================================================

export const saveTvApkSettings = async (data) => {

  try {

    const response = await axiosInstance.post(
      "/admin/tvapk/saveSettings",
      data,
      {
        headers: {
          Authorization: `Bearer ${ getToken() } `,
          "Content-Type": "multipart/form-data"

        }
      }
    );

    return response.data;

  } catch (error) {

    throw error;

  }

};

export const getTvApkSettings = async (tvApkId) => {

  try {

    const response = await axiosInstance.get(
      "/admin/tvapk/getSettings",
      {
        params: {
          tv_apk_id: tvApkId
        },
        headers: {
          Authorization: `Bearer ${ getToken() } `
        }
      }
    );

    return response.data;

  } catch (error) {

    console.error("Error in getTvApkSettings:", error);

    return false;

  }

};



// ======================================================
// TV APK FAQ
// ======================================================

export const addTvApkFaq = async (data) => {

  try {

    const response = await axiosInstance.post(
      "/admin/tvapk/addFaq",
      data,
      {
        headers: {
          Authorization: `Bearer ${ getToken() } `
        }
      }
    );

    return response.data;

  } catch (error) {

    throw error;

  }

};


export const updateTvApkFaq = async (data) => {

  try {

    const response = await axiosInstance.put(
      "/admin/tvapk/updateFaq",
      data,
      {
        headers: {
          Authorization: `Bearer ${ getToken() } `
        }
      }
    );

    return response.data;

  } catch (error) {

    throw error;

  }

};

export const deleteTvApkFaq = async ({ faq_id, tv_apk_id }) => {

  try {

    const response = await axiosInstance.delete(
      "/admin/tvapk/deleteFaq",
      {
        data: {
          faq_id,
          tv_apk_id
        },
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );

    return response.data;

  } catch (error) {

    console.error("Error in deleteTvApkFaq:", error);

    return false;

  }

};


export const getTvApkFaqs = async (tvApkId) => {

  try {

    const response = await axiosInstance.get(
      "/admin/tvapk/getFaqs",
      {
        params: {
          tv_apk_id: tvApkId
        },
        headers: {
          Authorization: `Bearer ${ getToken() } `
        }
      }
    );

    return response.data;

  } catch (error) {

    console.error("Error in getTvApkFaqs:", error);

    return false;

  }

};



// ======================================================
// TV APK BANNERS
// ======================================================

export const addTvApkBanner = async (data) => {

  try {

    const response = await axiosInstance.post(
      "/admin/tvapk/addBanner",
      data,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "multipart/form-data"
        }
      }
    );

    return response.data;

  } catch (error) {

    throw error;

  }

};


export const updateTvApkBanner = async (data) => {

  try {

    const response = await axiosInstance.put(
      "/admin/tvapk/updateBanner",
      data,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "multipart/form-data"
        }
      }
    );

    return response.data;

  } catch (error) {

    throw error;

  }

};

export const deleteTvApkBanner = async (bannerId) => {

  try {

    const response = await axiosInstance.delete(
      "/admin/tvapk/deleteBanner",
      {
        data: {
          banner_id: bannerId
        },
        headers: {
          Authorization: `Bearer ${ getToken() } `
        }
      }
    );

    return response.data;

  } catch (error) {

    console.error("Error in deleteTvApkBanner:", error);

    return false;

  }

};


export const getTvApkBanners = async (tvApkId) => {

  try {

    const response = await axiosInstance.get(
      "/admin/tvapk/getBanners",
      {
        params: {
          tv_apk_id: tvApkId
        },
        headers: {
          Authorization: `Bearer ${ getToken() } `
        }
      }
    );

    return response.data;

  } catch (error) {

    console.error("Error in getTvApkBanners:", error);

    return false;

  }

};

export const getTvConfig = async (appId) => {

  try {

    const response = await axiosInstance.get(
      "/tv/config",
      {
        params: {
          app_id: appId
        }
      }
    );

    return response.data;

  } catch (error) {

    console.error("Error in getTvConfig:", error);

    return false;

  }

};
